import { useState } from 'react';
import { useTheme } from '../zustand/ThemeStore';
import { UserSelector, CoreMetrics, TeamMembers, CallsTable } from '../components/dashboard';
import type { User } from '../types/dashboard';

export default function MainDashboard() {
  const isDarkMode = useTheme((state) => state.theme);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-black' : 'bg-gray-50'
    }`}>
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        
        {/* User Selection or Performance Cards */}
        {!selectedUser ? (
          <UserSelector 
            selectedUser={selectedUser}
            onUserSelect={setSelectedUser}
          />
        ) : (
          <CoreMetrics 
            selectedUser={selectedUser}
            onBackClick={() => setSelectedUser(null)}
          />
        )}

        {/* Team Members Section */}
        <TeamMembers />

        {/* Latest Calls Section */}
        <CallsTable />
      </div>
    </div>
  );
}
